import { Input, Component } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export type RadioValue = {
    text: string;
    value: any;
    disabled: boolean;
};

@Component({
    selector: 'ok-radio',
    template: `
        <label class="control-label">{{ label }}</label>
        @for (entry of possibleValues; track entry; let i = $index) {
            <div class="radio">
                <label>
                    <input
                        type="radio"
                        [attr.name]="name"
                        [value]="entry.value"
                        [checked]="boundValue === entry.value"
                        [disabled]="disabled || entry.disabled"
                        (click)="selectionMade(entry.value)"
                    />
                    <span [innerHTML]="entry.text"></span>
                </label>
            </div>
        }
    `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: OkRadioComponent,
            multi: true
        }
    ],
    standalone: false
})
export class OkRadioComponent implements ControlValueAccessor {
    @Input()
    possibleValues: RadioValue[] = [];
    @Input()
    name: string;
    @Input()
    label: string;
    @Input()
    disabled = false;
    @Input()
    allowDeselect = false;

    private _boundValue: any;
    propagateChange = (_: any) => {
        /* No change propagated */
    };

    get boundValue() {
        return this._boundValue;
    }

    set boundValue(val: any) {
        this._boundValue = val;
        this.propagateChange(this._boundValue);
    }

    selectionMade(value) {
        this.boundValue =
            this.boundValue === value && this.allowDeselect ? undefined : value;
    }

    /* Meet ControlValueAccessor Interface */
    // Do NOT propagate changes up here
    writeValue(value: any): void {
        this._boundValue = value;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = (changed) => fn.call(this, changed);
    }

    registerOnTouched(): void {
        /* No callback function registered OnTouched */
    }
    /** ***************************************/
}
